<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      if(
        !this.item.ListPrice
      ) {
        this.$noty.error("Please complete all of the required fields on this page before continuing.");
        this.loading = false;
        return;
      }
      this.$emit('setpage', 4);
      this.loading = false;
    }
  }
}
</script>

<template>
  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">

      <div class="title text-center mb-5">
        <Icon icon="ri:home-2-line" height="45" class="text-revinre mb-2" />
        <h3 class="mb-3" data-aos="fade-zoom-in">List price</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Determining the optimum price to list your property is important to maximize showings and profit. Below are a few automated property valuations from Zillow and RPR. For a more in-depth valuation of your property, you can request a comparative market analysis from one of our experienced brokers.</p>
      </div>

      <div class="card mb-4 border">
        <div class="row m-0">
          <div class="_w-110 d-none d-md-inline-block p-4 border-right border-light">
            <img :src="formatImage('/fm/revinre-nc/clip art/Real Estate Listings.png')" alt="" class="_w-60">
          </div>
          <div class="col-12 col-sm p-4">
            <h2 class="h3">{{item.Address}} {{item.City}} {{item.StateOrProvince}} {{item.PostalCode}}</h2>
            <p class="m-0 text-muted">
              <span class="mr-2"><Icon icon="ri:hotel-bed-line" /> Beds : {{item.BedroomsTotal ? item.BedroomsTotal : '?'}}</span>
              <span class="mr-2"><Icon icon="ri:contrast-drop-line" /> Baths : {{item.BathroomsTotalInteger ? item.BathroomsTotalInteger : '?'}}</span>
              <span class="mr-2"><Icon icon="ri:ruler-2-line" /> SQFT : {{item.LivingArea ? item.LivingArea : '?'}}</span>
            </p>
          </div>
        </div>
        <div class="row m-0">
          <div v-if="item.Latitude && item.Longitude" class="col-sm-6 p-0">
            <div data-aos="fade-zoom-in">
              <img class="w-100" :src="'https://maps.googleapis.com/maps/api/streetview?size=640x480&location='+item.Latitude+','+item.Longitude+'&pitch=10&key='+google_key">
            </div>
          </div>
          <div v-if="item.Latitude && item.Longitude" class="col-sm-6 p-0">
            <img class="w-100" :src="'https://maps.google.com/maps/api/staticmap?center='+item.Latitude+','+item.Longitude+'&zoom=15&markers='+item.Latitude+','+item.Longitude+'&size=640x480&key='+google_key">
          </div>
        </div>
        <div class="mb-4">
          <div class="row">
            <div class="col-sm-6 mt-4 text-center border-right border-light">
              <h2 v-if="item.valuations.zillow && item.valuations.zillow.amount > 0">{{formatPrice(item.valuations.zillow.amount, true, false)}}</h2>
              <p v-if="item.valuations.zillow && item.valuations.zillow.amount > 0" class="">Range: {{formatPrice(item.valuations.zillow.low, true, false)}} to {{formatPrice(item.valuations.zillow.high, true, false)}}</p>
              <h3 v-else>Valuation<br>not found</h3>
              <small class="text-muted">Powered by</small>
              <div class="mt-1"><a href="https://zillow.com" target="_blank"><img src="/images/zillow.png" class="_h-25"></a></div>
            </div>
            <div class="col-sm-6 mt-4 text-center">
              <h2 v-if="item.valuations.rpr && item.valuations.rpr.amount > 0">{{formatPrice(item.valuations.rpr.amount, true, false)}}</h2>
              <p v-if="item.valuations.rpr && item.valuations.rpr.amount > 0" class="">Range: {{formatPrice(item.valuations.rpr.low, true, false)}} to {{formatPrice(item.valuations.rpr.high, true, false)}}</p>
              <h3 v-else>Valuation<br>not found</h3>
              <small class="text-muted">Powered by</small>
              <div class="mt-1"><a href="https://www.narrpr.com/" target="_blank"><img src="/images/rpr.jpg" class="_h-25"></a></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-sm-12" data-aos="fade-zoom-in">
          <div class="form-group">
            <label for="field-list_price">List price <span class="text-danger" v-tippy content="This field is required.">*</span> </label>
            <w-money id="field-list_price" name="list_price" class="form-control" v-model="item.ListPrice" :decimal="false" required></w-money>
            <small class="text-muted">Once you have determined the best list price for your property, enter the amount and click next to continue.</small>
          </div>
        </div>
      </div>

      <div class="row py-5">
        <div class="col-6">
          <button type="button" class="btn btn-lg btn-success" @click="$emit('setpage', 2)" :disabled="loading"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Next <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>
</template>
